window.onscroll = function() {scrollFunction()};

let stickyHeader = document.querySelector("x-header.header");
let mainHeader = document.querySelector("header.shopify-section--header");


function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
   stickyHeader.classList.add("is-solid");
    mainHeader.style.position= "fixed";
  } else {
       stickyHeader.classList.remove("is-solid");
        mainHeader.style.position= "relative";
  }
}


document.addEventListener("DOMContentLoaded", function() {
    // Get the current URL
    const currentUrl = window.location.href;

    // Get all filter links
    const filterLinks = document.querySelectorAll(".collection-item-round a");

    // Loop through all filter links
    filterLinks.forEach(function(link) {
        // Check if the link href is part of the current URL
        if (currentUrl.includes(link.getAttribute("href").split("#")[0])) {
            // Add the "active" class to the matching link
            link.classList.add("active");
        }
    });
});


let mouseDown = false;
let startX, scrollLeft;
const slider = document.querySelector('.internal-paired-wrap');

const startDragging = (e) => {
  mouseDown = true;
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

const stopDragging = (e) => {
  mouseDown = false;
}

const move = (e) => {
  e.preventDefault();
  if(!mouseDown) { return; }
  const x = e.pageX - slider.offsetLeft;
  const scroll = x - startX;
  slider.scrollLeft = scrollLeft - scroll;
}

// Add the event listeners
slider.addEventListener('mousemove', move, false);
slider.addEventListener('mousedown', startDragging, false);
slider.addEventListener('mouseup', stopDragging, false);
slider.addEventListener('mouseleave', stopDragging, false);





